import { v4 as uuidv4 } from "uuid";
import { useCollapsePanel } from "hooks/useCollapsePanel";
import { getName } from "js/formatting";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";
import { useTranslation } from "react-i18next";

const DeprecatedBeneficiariesCard = ({ policyDetail }) => {
  const uuid = uuidv4();
  useCollapsePanel(uuid);
  const isPolicyHasBeneficiary = () => {
    return policyDetail?.beneficiaries?.primary?.length > 0;
  };
  const { t } = useTranslation();
  return (
    <>
      <div className="ui-card">
        <div className="p-4 xl:pt-6 xl:px-6">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center">
            <h2 className="mb-0">
              <button
                id={uuid}
                className="flex items-center group md:hidden"
                aria-controls={`${uuid}-panel`}
                aria-expanded="true"
                aria-label={t(
                  "AgentDeprecatedBeneficiariesCard-expand-collapse-btn-label"
                )}
              >
                <span className="inline-block p-1 rounded-full mr-1 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                  <svg
                    className="ui-icon ui-plus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-plus"></use>
                  </svg>
                  <svg
                    className="ui-icon ui-minus w-4 h-4"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-minus"></use>
                  </svg>
                </span>
                <span
                  className={`text-base font-body font-bold md:ui-no-badge-icon-inline`}
                >
                  {t("AgentDeprecatedBeneficiariesCard-title")}
                </span>
              </button>
              <span className="text-xl font-body font-bold hidden md:block">
                {t("AgentDeprecatedBeneficiariesCard-title")}
              </span>
            </h2>
          </div>
        </div>
        <hr className="ui-mobile-collapse" />
        <div
          id={`${uuid}-panel`}
          className="overflow-hidden h-20 p-4 md:h-auto xl:p-6"
        >
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t("AgentDeprecatedBeneficiariesCard-label-1")}
            </div>
            <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
              {policyDetail?.beneficiaries?.primary?.map((p, idx) => {
                return (
                  <div
                    key={`primaryBeneficiaries-${idx}`}
                    className="text-sm font-semibold text-theme-text-secondary"
                  >
                    {`${getName(p?.person)} - ${
                      p?.splitPercent ? `${p?.splitPercent}%` : ""
                    }`}
                  </div>
                );
              })}
            </div>
          </div>
          <hr />
          <div>
            <div className="text-xs text-theme-text-tertiary">
              {t("AgentDeprecatedBeneficiariesCard-label-2")}
            </div>
            <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
              {policyDetail?.beneficiaries?.contingent?.map((item, idx) => {
                return (
                  <div
                    key={`contingentBeneficiaries-${idx}`}
                    className="text-sm font-semibold text-theme-text-secondary"
                  >
                    {getName(item?.person)}
                  </div>
                );
              })}
            </div>
          </div>
          <CardDisclaimerBase
            disclaimer={t("AgentDeprecatedBeneficiariesCard-disclaimer")}
          />
        </div>
      </div>
    </>
  );
};

export default DeprecatedBeneficiariesCard;
